var map = {
	"./basic.js": 647,
	"./default.js": 659,
	"./error.js": 660,
	"./folio.js": 661,
	"./home.js": 662,
	"./listing.js": 663,
	"./project.js": 664
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 646;


//////////////////
// WEBPACK FOOTER
// ./src/js/templates nonrecursive ^(?!.*_).*\.js$
// module id = 646
// module chunks = 0